import { createSlice } from '@reduxjs/toolkit'

export const structureCategoriesSlice = createSlice({
  name: 'structureCategories',
  initialState: {
    value: null,
  },
  reducers: {
    setStructureCategories: (state,action) => {
      state.value = action.payload
    },
    resetStructureCategories: (state) => {
        state.value = null
    }
  },
})

export const { setStructureCategories, resetStructureCategories } = structureCategoriesSlice.actions
export default structureCategoriesSlice.reducer